import { adaptEventHandler } from '../../../utils';

/** These props have been excluded:
 * - style
 * - className
 * - analyticsContext
 * - disabledDateFilter - this prop is not working due to same issue as DatePicker. The function definition is unable to be retreived from WebRuntime.
 * /
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::7b9f89c1d4b9ad2f3876f450215dc1c9>>
 * @codegenId #calendar
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen calendar
 * @codegenParams { "props": { "day": true, "defaultDay": true, "defaultMonth": true, "defaultYear": true,"defaultPreviouslySelected": true, "defaultSelected": true, "disabled": true, "disabledDateFilter": true, "maxDate": true, "minDate": true, "nextMonthLabel": true, "onBlur": { "value": "adaptEventHandler(onBlur)" }, "onChange": true, "onFocus": { "value": "adaptEventHandler(onFocus)" }, "onSelect": true, "previouslySelected": true, "previousMonthLabel": true, "selected": true, "today": true, "year": true, "locale": true, "testId" : true, "weekStartDay": true, "tabIndex": true } }
 * @codegenDependency ../../../../../../../design-system/calendar/src/types.tsx <<SignedSource::7f3d03689dc06bfe21c14f42334c53e2>>
 * @codegenDependency ../../../../../../../analytics/analytics-next/src/hocs/withAnalyticsEvents.tsx <<SignedSource::f7b482ba9a0c9d04782373e7884788f4>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/components/header.tsx <<SignedSource::71bfd3bfd07047d090b47f252095a4e1>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/components/week-days.tsx <<SignedSource::ae2cb57d1329a3206dfbce7505f640cc>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/components/week-header.tsx <<SignedSource::37951f0e730d21a76dc66427f4b9a1ad>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/constants.tsx <<SignedSource::4762fa3e81d16c1076975d3282886edd>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/hooks/use-calendar-ref.tsx <<SignedSource::4a04049941ee163abfb9e1414b7bde26>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/hooks/use-controlled-date-state.tsx <<SignedSource::c8a72b08178026ba433c4aed8f222415>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/hooks/use-focusing.tsx <<SignedSource::92bb449dbe5ffd74571b3b46c200880b>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/hooks/use-get-weeks.tsx <<SignedSource::157ed597db5d6b5528c884b56313b355>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/hooks/use-handle-date-change.tsx <<SignedSource::dd04562066fd437855432186ce6498fb>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/hooks/use-handle-date-select.tsx <<SignedSource::fa9baaba7012145fddc30678582e9bda>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/hooks/use-locale.tsx <<SignedSource::917784cca3aebb6f4d6327b02b77b19e>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/internal/hooks/use-unique-id.tsx <<SignedSource::7608e746e6ffa077094b34935d6a1884>>
 * @codegenDependency ../../../../../../../design-system/calendar/src/calendar.tsx <<SignedSource::c92e859c8e87db9cf79c3f4fbaa0189d>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import type { RenderFn } from '@atlassian/forge-ui-types';
import PlatformCalendar from '@atlaskit/calendar';

type PlatformCalendarProps = React.ComponentProps<typeof PlatformCalendar>;

export type CalendarProps = Pick<
  PlatformCalendarProps,
  'day' | 'defaultDay' | 'defaultMonth' | 'defaultYear' | 'defaultPreviouslySelected' | 'defaultSelected' | 'disabled' | 'disabledDateFilter' | 'maxDate' | 'minDate' | 'nextMonthLabel' | 'onBlur' | 'onChange' | 'onFocus' | 'onSelect' | 'previouslySelected' | 'previousMonthLabel' | 'selected' | 'today' | 'year' | 'locale' | 'testId' | 'weekStartDay' | 'tabIndex'
>;

export const Calendar = (props: Parameters<RenderFn>[0]) => {
  const {
    day,
    defaultDay,
    defaultMonth,
    defaultYear,
    defaultPreviouslySelected,
    defaultSelected,
    disabled,
    disabledDateFilter,
    maxDate,
    minDate,
    nextMonthLabel,
    onBlur,
    onChange,
    onFocus,
    onSelect,
    previouslySelected,
    previousMonthLabel,
    selected,
    today,
    year,
    locale,
    testId,
    weekStartDay,
    tabIndex,
  } = props.forgeDoc.props as CalendarProps;
  return (
    <PlatformCalendar
      day={day}
      defaultDay={defaultDay}
      defaultMonth={defaultMonth}
      defaultYear={defaultYear}
      defaultPreviouslySelected={defaultPreviouslySelected}
      defaultSelected={defaultSelected}
      disabled={disabled}
      disabledDateFilter={disabledDateFilter}
      maxDate={maxDate}
      minDate={minDate}
      nextMonthLabel={nextMonthLabel}
      onBlur={adaptEventHandler(onBlur)}
      onChange={onChange}
      onFocus={adaptEventHandler(onFocus)}
      onSelect={onSelect}
      previouslySelected={previouslySelected}
      previousMonthLabel={previousMonthLabel}
      selected={selected}
      today={today}
      year={year}
      locale={locale}
      testId={testId}
      weekStartDay={weekStartDay}
      tabIndex={tabIndex}
    />
  );
};
/**
 * @codegenEnd
 */